import {EOperatorName} from 'src/constants';
import {EEditorRegExpType, TEditorRegexp} from 'src/containers/EditorWithSelector/definitions';
import {EResellerIds} from 'src/containers/User/definitions';

const allowedRegexps: TEditorRegexp[] = [
  {value: '%w', type: EEditorRegExpType.STATIC},
  {value: '%d', type: EEditorRegExpType.STATIC},
  {
    type: EEditorRegExpType.LIMITED,
    value: '%d{1,n}',
    create: (n) => `%d{1,${n}}`,
    match: (value) => value.match(/^%d{1,\d+}/)?.[0] ?? '',
    matchLimit: (value) => {
      const limit = value.match(/%d{1,(?<limit>\d+)}/)?.groups?.limit;

      return limit ? Number(limit) : -1;
    },
  },
  {
    type: EEditorRegExpType.LIMITED,
    value: '%w{1,n}',
    create: (n) => `%w{1,${n}}`,
    match: (value) => value.match(/^%w{1,\d+}/)?.[0] ?? '',
    matchLimit: (value) => {
      const limit = value.match(/%w{1,(?<limit>\d+)}/)?.groups?.limit;

      return limit ? Number(limit) : -1;
    },
  },
];

enum EExampleType {
  REGEX = 'REGEX',
  VARIABLE = 'VARIABLE',
}

type TExampleType = keyof typeof EExampleType;

enum ESmsStep {
  DATA = 'DATA',
  CONTENT = 'CONTENT',
}

enum ESmsCategory {
  SERVICE = 'SERVICE',
  TEMPLATE_ADV = 'TEMPLATE_ADV',
  AUTHORIZATION = 'AUTHORIZATION',
  // category for summary report page
  ADVERTISEMENT = 'ADVERTISEMENT',
}

export enum EMultiApproveStatus {
  FULLY_APPROVED = 'FULLY_APPROVED',
  PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
  REJECTED = 'REJECTED',
  PENDING = 'PENDING',
  NOT_SENT = 'NOT_SENT',
}

type TCategoryOperator = {
  providerCode: EOperatorName;
};

const RESELLERS_WITHOUT_STEP_TARIFFICATION = [
  EResellerIds.BLR_FIRST_ID,
  EResellerIds.BLR_SECOND_ID,
];

const DISABLE_REQUESTED_COMMENT = 'DISABLE_REQUESTED';

export type {TExampleType, TCategoryOperator};
export {
  ESmsStep,
  allowedRegexps,
  EExampleType,
  ESmsCategory,
  RESELLERS_WITHOUT_STEP_TARIFFICATION,
  DISABLE_REQUESTED_COMMENT,
};
